/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { CarriersFilters } from '../types'

type ContextState = {
  filters: CarriersFilters
  setFilters: Dispatch<SetStateAction<CarriersFilters>>
  isCarriersSync: boolean
  setIsCarriersSync: Dispatch<SetStateAction<boolean>>
  resetFilters: () => void
  resetTriggered: number
}

export const initialCarriersFiltersState: ContextState = {
  filters: { page: 1, limit: 10, orderBy: 'ASC' },
  setFilters: () => {},
  isCarriersSync: false,
  setIsCarriersSync: () => {},
  resetFilters: () => {},
  resetTriggered: 0,
}

const CarriersContext = React.createContext<ContextState>(initialCarriersFiltersState)

type CarriersFiltersProviderProps = {
  children: React.ReactNode
}

export function CarriersFiltersProvider({ children }: CarriersFiltersProviderProps) {
  const [isCarriersSync, setIsCarriersSync] = useState<boolean>(false)
  const [filters, setFilters] = useState<CarriersFilters>(initialCarriersFiltersState.filters)
  const [resetTriggered, setResetTriggered] = useState<number>(0)
  const [search] = useSearchParams()
  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters(initialCarriersFiltersState.filters)
    }
  }, [resetTriggered])

  useEffect(() => {
    if (filters && search.get('service') && !filters.asnum) {
      const timeout = setTimeout(
        () =>
          setFilters(state => ({
            ...state,
            asnum: Number(search.get('service')) ?? undefined,
            page: initialCarriersFiltersState.filters.page,
          })),
        0,
      )

      return () => clearTimeout(timeout)
    } else {
      setFilters(initialCarriersFiltersState.filters)
    }
  }, [search])

  return (
    <CarriersContext.Provider
      value={{
        filters,
        setFilters,
        isCarriersSync,
        setIsCarriersSync,
        resetFilters,
        resetTriggered,
      }}
    >
      {children}
    </CarriersContext.Provider>
  )
}

export function useCarriersContext(): ContextState {
  const context = useContext(CarriersContext)
  if (!context)
    throw Error('This hook can only be used under the CarriersFiltersProvider component')
  return context
}
